import { AddBudgetFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddBudgetFormModalContext = () => {
  const context = useContext(AddBudgetFormModalContext)

  if (!context) throw new Error('useAddBudgetFormModalContext have to be wrapped by AddBudgetFormModalContextProvider')
  
  return context
} 